import * as Yup from "yup";
import { parseCurrencyString } from "@/utils/parseCurrencyString";

export const productSchema = Yup.object().shape({
  product: Yup.object().shape({
    name: Yup.string().required("O nome é obrigatório"),
    description: Yup.string().nullable(),
    category_id: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .nullable(),
    brand_id: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .nullable(),
    display_in_agenda: Yup.boolean().nullable(),
    subscriber_discount: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value,
      )
      .integer("Deve ser um número inteiro")
      .nullable(),
  }),
  product_stock: Yup.object().shape({
    purchase_price: Yup.string()
      .transform((value) => (value === "" ? "0" : value))
      .test("is-valid", "Preço de compra inválida", (value) => {
        const num = parseFloat(value ?? "0");
        return !isNaN(num) && num >= 0;
      }),

    sale_price: Yup.string()
      .transform((value) => (value === "" ? "0" : value))
      .test("is-valid", "Preço de venda inválida", (value) => {
        const num = parseFloat(value ?? "0");
        return !isNaN(num) && num >= 0;
      }),

    commission: Yup.string()
      .transform((value) => (value === "" ? "0" : value))
      .test("is-valid", "Comissão inválida", (value) => {
        const num = parseFloat(value ?? "0");
        return !isNaN(num) && num >= 0;
      }),
    employee_price: Yup.string()
      .transform((value) => (value === "" ? "0" : value))
      .test("is-valid", "Preço do funcionário inválido", (value) => {
        const num = parseFloat(value ?? "0");
        return !isNaN(num) && num >= 0;
      }),

    quantity: Yup.number()
      .transform((value, originalValue) => Number(originalValue))
      .typeError("Quantidade deve ser um número")
      .required("Quantidade é obrigatória"),
    minimum_quantity: Yup.number()
      .transform((value, originalValue) => Number(originalValue))
      .nullable(),
  }),
});
